export const initialState = {
  details: null,
  loading: false,
  notFound: false
}

export const INVOICE_REQUEST = 'INVOICE_REQUEST'
export const INVOICE_SUCCESS = 'INVOICE_SUCCESS'
export const INVOICE_ERROR = 'INVOICE_ERROR'
export const INVOICE_NOT_FOUND = 'INVOICE_NOT_FOUND'

export const getInvoiceData = id => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: INVOICE_REQUEST })

  return httpRequest.get(`/order/${id}`)
    .then(res => {
      dispatch({
        type: INVOICE_SUCCESS,
        invoice: res.data
       })
       return Promise.resolve(res.data)
    })
    .catch(err => {
      if (err.response.status === 404) {
        dispatch({
          type: INVOICE_NOT_FOUND
        })
        return Promise.resolve()
      } else {
        dispatch({
          type: INVOICE_ERROR,
          error: err.response.data.error
        })
        return Promise.reject(err)
      }
    })
}

const ACTION_HANDLERS = {
  [INVOICE_REQUEST]: state => ({
    ...state,
    error: null,
    loading: true
  }),
  [INVOICE_SUCCESS]: (state, { invoice }) => ({
    ...state,
    details: invoice,
    error: null,
    loading: false
  }),
  [INVOICE_ERROR]: (state, { error }) => ({
    ...state,
    details: null,
    error,
    loading: false
  }),
  [INVOICE_NOT_FOUND]: () => ({
    ...initialState,
    notFound: true
  })
}

export default function invoiceReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/invoice.js